import { useFormikContext } from 'formik'
import { Button } from 'native-base'

import { trackEvent } from '../../../utils/analytics-v2'
import { ModalFormType } from '../InstructionsModal'
import { ToastAlertProps } from './ToastAlert'

export interface AddInstructionsLaterButtonProps {
  closeModal: ({
    clearAddressFields,
    clearGeocode,
    showToast,
    toastProps,
  }: {
    clearAddressFields?: boolean
    clearGeocode?: boolean
    showToast?: boolean
    toastProps?: ToastAlertProps
  }) => void
  cancelText?: string
}

export const AddInstructionsLaterButton = ({ closeModal, cancelText }: AddInstructionsLaterButtonProps) => {
  const { resetForm } = useFormikContext<ModalFormType>()
  const onPress = () => {
    closeModal({
      clearAddressFields: false,
      clearGeocode: false,
      showToast: false,
    })
    resetForm()
    trackEvent('dismiss_instructions', {})
  }

  return (
    <Button onPress={onPress} variant="ghost" _text={{ color: 'black' }}>
      {cancelText || 'Add Instructions Later'}
    </Button>
  )
}
